module.exports = __webpack_public_path__ + "img/technology.9c2cef41.png";